import { ReactNode } from 'react';
import { FormattedMessage, defineMessages } from 'dibs-react-intl';

export const contactDealerTitle = (
    <FormattedMessage
        id="dbl.ContactDealerModal.contactDealerTitle"
        defaultMessage="Ask the Seller a Question"
    />
);

export const makeOfferContactTitle = (
    <FormattedMessage
        id="dbl.ContactDealerModal.makeOfferTitle"
        defaultMessage="Not ready to make an offer?"
    />
);

export const contactDealerSubtitle = (
    <FormattedMessage
        id="dbl.ContactDealerModal.contactDealerSubtitle"
        defaultMessage="The seller is here to help with any questions about this piece."
    />
);

export const requestImagesTitle = (
    <FormattedMessage
        id="dbl.ContactDealerModal.requestImagesTitle"
        defaultMessage="Request More Images"
    />
);

export const requestCustomizationTitle = (
    <FormattedMessage
        id="dbl.ContactDealerModal.requestCustomizationTitle"
        defaultMessage="Request Customization"
    />
);

export const requestDyoCustomizationTitle = (
    <FormattedMessage
        id="dbl.ContactDealerModal.requestDyoCustomizationTitle"
        defaultMessage="Design Your Own"
    />
);

export const requestDyoCustomizationSubtitle = (
    <FormattedMessage
        id="dbl.ContactDealerModal.requestDyoCustomizationSubtitle"
        defaultMessage="Contact the Seller"
    />
);

export const nameFieldLabel = (
    <FormattedMessage id="dbl.ContactDealerModal.nameFieldLabel" defaultMessage="Your Name" />
);

export const emailFieldLabel = (
    <FormattedMessage id="dbl.ContactDealerModal.emailFieldLabel" defaultMessage="Your Email" />
);

export const messageFieldLabel = (
    <FormattedMessage id="dbl.ContactDealerModal.messageFieldLabel" defaultMessage="Your Message" />
);

export const submitMessage = (
    <FormattedMessage id="dbl.ContactDealerModal.submitMessage" defaultMessage="Send" />
);

export const makeOfferMessage = (
    <FormattedMessage id="dbl.ContactDealerModal.makeOfferMessage" defaultMessage="Make an offer" />
);

export const fullMakeOfferMessageWithCTA = ({ CTA }: { CTA: ReactNode }): ReactNode => (
    <FormattedMessage
        id="dbl.ContactDealerModal.makeOfferMessageWithCTA"
        defaultMessage="Ready to negotiate? {CTA}"
        values={{ CTA }}
    />
);

export const viewShippingOptions = (
    <FormattedMessage
        id="dbl.ContactDealerModal.viewShippingOptions"
        defaultMessage="View shipping options"
    />
);

export const stringMessages = defineMessages({
    messagePlaceholder: {
        id: 'dbl.ContactDealerModal.messagePlaceholder',
        defaultMessage: 'Send a message to this seller to request more details or discuss price.',
    },
    requestCustomizationsPlaceholder: {
        id: 'dbl.ContactDealerModal.requestCustomizationsPlaceholder',
        defaultMessage: 'Send a message to this seller to request customization.',
    },
    requestDyoCustomizationsPlaceholder: {
        id: 'dbl.ContactDealerModal.requestDyoCustomizationsPlaceholder',
        defaultMessage:
            'Send a request for more details about this gemstone and information regarding the customization process.',
    },
    requestImagesMessage: {
        id: 'dbl.ContactDealerModal.requestImagesMessage',
        defaultMessage: 'I would like to request additional images of this piece.',
    },
    requestPriceMessage: {
        id: 'dbl.ContactDealerModal.requestPriceMessage',
        defaultMessage: `I'm interested in this piece. Can you please confirm the price?`,
    },
});
